import { getAllTeams, getTeams } from "../services/apiTeam";
import { useMappedQuery } from "./queryUtils";

export function useTeams() {
  return useMappedQuery({
    queryKey: ["teams"],
    queryFn: getAllTeams,
    dataKey: "teams",
  });
}

export function useAllTeams() {
  return useMappedQuery({
    queryKey: ["all-teams"],
    queryFn: getTeams,
    dataKey: "teams",
  });
}
